export default {
    // initialization of the app
    language: 'en',
    webpSupported: true,
    showStickyHeader: true,
    loginToken: null,
    username: null,
    profile: null,
};
